import { createFileRoute } from "@tanstack/react-router";
import ProductHub from "@/pages/ProductHub";
import { hubArticlesQueryOptions } from "@/lib/hubArticles";

export const Route = createFileRoute("/generators/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(hubArticlesQueryOptions("generators")).catch(() => null);
  },
  component: () => <ProductHub hubSlug="generators" />,
});
